module.exports = __webpack_public_path__ + "static/media/info-gameinfo.d37cee28.png";